query TopVendorExpensesQuery($company_id: ID!) {
  topVendorExpenses(company_id: $company_id) {
    vendorName
    expenses {
      date
      amount
    }
  }
}
